import { Search } from "@mui/icons-material"
import { Box, IconButton, Stack, TextField, Tooltip, Typography } from "@mui/material"
import { useState } from "react"
import ExistingContactModal from "./ExistingContactModal"

const SoldTo = ({ quote, patchQuote, readOnly = false }) => {
    const [contactModal, setContactModal] = useState(false)

    const handleOpenContactModal = () => setContactModal(true)
    const handleCloseContactModal = () => setContactModal(false)

    const toParty = (contact) => {
        if (!contact) return null;

        const company = contact.organizationName || contact.company || contact.customerName || "";
        const email = contact.primaryEmail || "";
        const phone = contact.phone || contact.phoneNumber || "";
        const fax = contact.fax || "";
        const title = contact.jobTitle || contact.contactJobTitle || "";
        const country = contact.country || contact.countryCode || "USA";
        const contactName =
            contact.contact ||
            contact.name ||
            [contact.firstName, contact.lastName].filter(Boolean).join(" ") ||
            "";
        const address1 =
            contact.address ||
            "";
        const city = contact.city || "";
        const state = contact.state || "";
        const zip = contact.zip || contact.postalCode || "";

        return {
            company,
            contact: contactName,
            address1,
            city,
            state,
            zip,
            phone,
            fax,
            email,
            title,
            country,
        };
    };

    const patchSoldTo = async (selectedContact) => {
        const party = toParty(selectedContact);
        if (!party) return;

        await patchQuote({ customerId: selectedContact.customerId, soldTo: party });
    };

    const patchShipTo = async (selectedContact) => {
        const party = toParty(selectedContact);
        if (!party) return;

        await patchQuote({ customerId: selectedContact.customerId, shipTo: party });
    };

    const patchAllParties = async (selectedContact) => {
        const party = toParty(selectedContact);
        if (!party) return;

        await patchQuote({ customerId: selectedContact.customerId, soldTo: party, shipTo: party, billTo: party });
    };

    const fieldProps = { sx: { margin: "0.5em" }, fullWidth: true, disabled: readOnly };

    return (
        <Box className="hive-quote-sold-to" sx={{ flexGrow: 1 }}>
            <ExistingContactModal open={contactModal} handleClose={handleCloseContactModal} onSoldTo={patchSoldTo} onShipTo={patchShipTo} onAll={patchAllParties} />

            <Stack className="hive-quote-sold-to-actions" direction="row" spacing={1}>
                <Tooltip title="Find Existing Contact">
                    <span>
                        <IconButton className="hive-quote-sold-to-search" color="primary" onClick={handleOpenContactModal} disabled={readOnly}>
                            <Search/>
                        </IconButton>
                    </span>
                </Tooltip>
            </Stack>
            <div className="hive-quote-sold-to-grid" style={{display: "flex", flexWrap: "wrap", justifyContent: "space-evenly"}}>

                <div className="col-12 col-md-5 hive-quote-party-card" style={{border: "1px dashed #b3aeaeff", padding: "1.5em"}}>
                    <Typography variant="h6" gutterBottom>Sold To</Typography>
                    <TextField {...fieldProps} label="Company" value={quote?.soldTo?.company || ""} onChange={(e) => patchQuote({ "soldTo.company": e.target.value })} />
                    <TextField {...fieldProps} label="Contact" value={quote?.soldTo?.contact || ""} onChange={(e) => patchQuote({ "soldTo.contact": e.target.value })} />
                    <TextField {...fieldProps} label="Title" value={quote?.soldTo?.title || ""} onChange={(e) => patchQuote({ "soldTo.title": e.target.value })} />
                    <TextField {...fieldProps} label="Address" value={quote?.soldTo?.address1 || ""} onChange={(e) => patchQuote({ "soldTo.address1": e.target.value })} />
                    <TextField {...fieldProps} label="City" value={quote?.soldTo?.city || ""} onChange={(e) => patchQuote({ "soldTo.city": e.target.value })} />
                    <TextField {...fieldProps} label="State" value={quote?.soldTo?.state || ""} onChange={(e) => patchQuote({ "soldTo.state": e.target.value })} />
                    <TextField {...fieldProps} label="Zip" value={quote?.soldTo?.zip || ""} onChange={(e) => patchQuote({ "soldTo.zip": e.target.value })} />
                    <TextField {...fieldProps} label="Country" value={quote?.soldTo?.country || ""} onChange={(e) => patchQuote({ "soldTo.country": e.target.value })} />
                    <TextField {...fieldProps} label="Phone" value={quote?.soldTo?.phone || ""} onChange={(e) => patchQuote({ "soldTo.phone": e.target.value })} />
                    <TextField {...fieldProps} label="Email" value={quote?.soldTo?.email || ""} onChange={(e) => patchQuote({ "soldTo.email": e.target.value })} />
                </div>

                <div className="col-12 col-md-5 hive-quote-party-card" style={{border: "1px dashed #b3aeaeff", padding: "1.5em"}}>
                    <Typography variant="h6" gutterBottom>Ship To</Typography>
                    <TextField {...fieldProps} label="Company" value={quote?.shipTo?.company || ""} onChange={(e) => patchQuote({ "shipTo.company": e.target.value })} />
                    <TextField {...fieldProps} label="Contact" value={quote?.shipTo?.contact || ""} onChange={(e) => patchQuote({ "shipTo.contact": e.target.value })} />
                    <TextField {...fieldProps} label="Title" value={quote?.shipTo?.title || ""} onChange={(e) => patchQuote({ "shipTo.title": e.target.value })} />
                    <TextField {...fieldProps} label="Address" value={quote?.shipTo?.address1 || ""} onChange={(e) => patchQuote({ "shipTo.address1": e.target.value })} />
                    <TextField {...fieldProps} label="City" value={quote?.shipTo?.city || ""} onChange={(e) => patchQuote({ "shipTo.city": e.target.value })} />
                    <TextField {...fieldProps} label="State" value={quote?.shipTo?.state || ""} onChange={(e) => patchQuote({ "shipTo.state": e.target.value })} />
                    <TextField {...fieldProps} label="Zip" value={quote?.shipTo?.zip || ""} onChange={(e) => patchQuote({ "shipTo.zip": e.target.value })} />
                    <TextField {...fieldProps} label="Country" value={quote?.shipTo?.country || ""} onChange={(e) => patchQuote({ "shipTo.country": e.target.value })} />
                    <TextField {...fieldProps} label="Phone" value={quote?.shipTo?.phone || ""} onChange={(e) => patchQuote({ "shipTo.phone": e.target.value })} />
                    <TextField {...fieldProps} label="Email" value={quote?.shipTo?.email || ""} onChange={(e) => patchQuote({ "shipTo.email": e.target.value })} />
                </div>

                <div className="col-12 col-md-5 hive-quote-party-card" style={{border: "1px dashed #b3aeaeff", padding: "1.5em", marginTop: "1em"}}>
                    <Typography variant="h6" gutterBottom>Bill To</Typography>
                    <TextField {...fieldProps} label="Company" value={quote?.billTo?.company || ""} onChange={(e) => patchQuote({ "billTo.company": e.target.value })} />
                    <TextField {...fieldProps} label="Contact" value={quote?.billTo?.contact || ""} onChange={(e) => patchQuote({ "billTo.contact": e.target.value })} />
                    <TextField {...fieldProps} label="Title" value={quote?.billTo?.title || ""} onChange={(e) => patchQuote({ "billTo.title": e.target.value })} />
                    <TextField {...fieldProps} label="Address" value={quote?.billTo?.address1 || ""} onChange={(e) => patchQuote({ "billTo.address1": e.target.value })} />
                    <TextField {...fieldProps} label="City" value={quote?.billTo?.city || ""} onChange={(e) => patchQuote({ "billTo.city": e.target.value })} />
                    <TextField {...fieldProps} label="State" value={quote?.billTo?.state || ""} onChange={(e) => patchQuote({ "billTo.state": e.target.value })} />
                    <TextField {...fieldProps} label="Zip" value={quote?.billTo?.zip || ""} onChange={(e) => patchQuote({ "billTo.zip": e.target.value })} />
                    <TextField {...fieldProps} label="Country" value={quote?.billTo?.country || ""} onChange={(e) => patchQuote({ "billTo.country": e.target.value })} />
                    <TextField {...fieldProps} label="Phone" value={quote?.billTo?.phone || ""} onChange={(e) => patchQuote({ "billTo.phone": e.target.value })} />
                    <TextField {...fieldProps} label="Email" value={quote?.billTo?.email || ""} onChange={(e) => patchQuote({ "billTo.email": e.target.value })} />
                </div>

            </div>

        </Box>
    )
}

export default SoldTo
